namespace GeniuzPOS.ReportMasterData {
    export interface Report_1410Form {
    }

    export class Report_1410Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1410';
    }
}
